import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import './AdminDashboard.css';

// Remove console.logs in production
  if (process.env.NODE_ENV !== "development") {
    console.log = () => {};
  }
  
const QuestionList = ({ filter, questions: propQuestions, onSubmit, onEdit, onCopy }) => {
  const [questions, setQuestions] = useState(propQuestions);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setQuestions(propQuestions);
    // Reset search when the question list or filter changes
    setSearchTerm('');
  }, [propQuestions, filter]);

  const handleDelete = (question_id) => {
    console.log('🗑️ Delete clicked for ID:', question_id);
    const confirmDelete = window.confirm('Are you sure you want to delete this question? This action cannot be undone.');
    if (!confirmDelete) return;

    onSubmit({ question_id }, 'delete');
  };

  const handleEdit = (question) => {
    console.log('✏️ Edit clicked for question:', question);
    onEdit(question);
  };

  const handleCopy = (question) => {
    console.log('📋 Copy clicked for question:', question);
    const copiedQuestion = {
      ...question,
      question_id: null, // Ensure it’s a new question
      question_number:
        Math.max(...questions.map((q) => Number(q.question_number || 0))) + 1 || 1,
      status: filter,
      tempKey: uuidv4(), // Add temporary key for unsaved questions
    };
    console.log('📋 Copied question prepared:', copiedQuestion);
    if (onCopy) onCopy(copiedQuestion);
  };

  const filteredQuestions = questions.filter((q) => q.status === filter);
  const reversedQuestions = [...filteredQuestions].sort(
    (a, b) => Number(b.question_number) - Number(a.question_number)
  );

    // Finally apply search filter (case-insensitive on question text or number)
  const displayedQuestions = reversedQuestions.filter((q) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      q.question_text.toLowerCase().includes(term) ||
      String(q.question_number).includes(term)
    );
  });
  
  console.log('Rendering with filteredQuestions:', filteredQuestions);
  return (
    <div className="question-list-container">
      <h5>{filter} Questions</h5>

       {/* Search Bar */}
      <div className="search-container">
        <input
          type="text"
          placeholder={`Search ${filter.toLowerCase()} questions by text or number...`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="question-search-input"
        />
        {searchTerm && (
          <button
            className="clear-search-btn"
            onClick={() => setSearchTerm('')}
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>
      
    <ul className="question-list">
        {displayedQuestions.length === 0 ? (
          <li>
            {searchTerm
              ? 'No questions match your search.'
              : 'No questions available for this filter.'}
          </li>
        ) : (
          displayedQuestions.map((question) => (
            <li
              key={question.question_id || question.tempKey || uuidv4()}
              className="question-item"
            >
              <p>
                <strong>Q{question.question_number}: </strong>
                {question.question_text}
              </p>
              <div className="buttons-container-list">
                <button className="copy-btn" onClick={() => handleCopy(question)}>
                  Copy
                </button>
                <button className="edit-btn" onClick={() => handleEdit(question)}>
                  Edit
                </button>
                <button
                  className="delete-btn"
                  onClick={() => handleDelete(question.question_id)}
                >
                  Delete
                </button>
              </div>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default QuestionList;